// Presenter language code -> team-management locale-bundle key.
//
// The presenter (stpancras-presenter-app) is the source of truth for the
// language code it pushes to this embedded app over zoid (`currentLanguage`
// / `currentUser.presenterLanguage`). Most codes are 1:1 with our locale
// directory names under `./locales/<code>/team.json`, but a few presenter
// codes are NOT our on-disk name and must be rewritten here.
//
// Known rewrite:
//   `pt_BR` -> `br`
//     The presenter's `setPresenterLang` mutation rewrites Brazilian
//     Portuguese `br` -> `pt_BR` before it lands in `state.presenterLocale`
//     (stpancras-presenter-app/src/vuex/mutations/index.js). We ship the
//     Brazilian translation under `br/` and have no `pt_BR` bundle, so the
//     raw `pt_BR` matched nothing and Brazilian users silently fell back to
//     English. Map it back to `br`.
//
// This is the ONE place both host boundaries agree on the mapping:
//   - the initial `hostLanguageDetector` (detector.ts), and
//   - the runtime language-switch bridge (I18nLanguageBridge.tsx).
// Normalising only one leaves a mid-session language SWITCH rendering the
// wrong language, so both call this.
export function toTeamLocale(
  hostLang: string | null | undefined,
): string | null {
  if (!hostLang) return null;
  // The presenter emits `pt_BR` (underscore). Be lenient about case and the
  // `-`/`_` separator so an upstream code style change doesn't reopen the bug.
  const normalized = hostLang.toLowerCase().replace("-", "_");
  if (normalized === "pt_br") return "br";
  return hostLang;
}
